var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 7.03c0-1.33-1.06-2.413-2.363-2.413-1.304 0-2.365 1.083-2.365 2.414 0 .865 1.237 2.852 2.365 4.367 1.126-1.515 2.363-3.504 2.363-4.367zm-6.311 0C7.064 4.809 8.836 3 11.012 3s3.946 1.808 3.946 4.03c0 1.972-2.78 5.5-3.337 6.186l-.61.751-.61-.75c-.556-.688-3.337-4.215-3.337-6.186zm3.144.012A.8.8 0 0 1 11 6.233a.8.8 0 0 1 .792.809.8.8 0 0 1-.792.808.8.8 0 0 1-.792-.808zm7.322 3.345c1.915 1.04 2.97 2.482 2.97 4.06 0 1.577-1.055 3.019-2.97 4.06C15.699 19.503 13.35 20 11 20c-2.35 0-4.7-.498-6.53-1.492-1.915-1.042-2.97-2.484-2.97-4.062 0-1.577 1.054-3.018 2.97-4.059l.744 1.428c-1.355.736-2.13 1.694-2.13 2.631 0 .939.775 1.898 2.13 2.634 3.192 1.734 8.382 1.734 11.572 0 1.354-.736 2.13-1.695 2.13-2.634 0-.937-.776-1.895-2.13-2.631l.744-1.428z"
  })));
};

export default SvgLocation;